module.exports = __webpack_public_path__ + "img/bar_multi.0e71f0b8.svg";